import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=c33f7bf6&scoped=true"
import script from "./QuestionCard.vue?vue&type=script&lang=js"
export * from "./QuestionCard.vue?vue&type=script&lang=js"
import style0 from "./QuestionCard.vue?vue&type=style&index=0&id=c33f7bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33f7bf6",
  null
  
)

export default component.exports